export enum DangerousAttackAttribute {
  KeyPass = 842,
}
